import { render, staticRenderFns } from "./consultaAvancada.vue?vue&type=template&id=a4969a86&scoped=true"
import script from "./consultaAvancada.vue?vue&type=script&lang=js"
export * from "./consultaAvancada.vue?vue&type=script&lang=js"
import style0 from "./consultaAvancada.vue?vue&type=style&index=0&id=a4969a86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4969a86",
  null
  
)

export default component.exports